module.exports = __webpack_public_path__ + "img/dCarbonLogo.f13fd3c2.png";